import { collection, query, where, getDocs, deleteDoc, addDoc, doc, updateDoc } from 'firebase/firestore';
import { DIGITAL_PRODUCTS } from '../models/digitalProducts.js';
import { SUBSCRIPTION_TIERS } from '../models/subscription.js';

export default async function setupOrganisationProducts(db, organisationId, subscriptionPlan, selectedProductIds, currentUser = null) {
  try {
    // Ensure selectedProductIds is an array
    const productIds = Array.isArray(selectedProductIds) 
      ? selectedProductIds 
      : typeof selectedProductIds === 'string' 
        ? [selectedProductIds] 
        : [];

    // Provide fallback for currentUser
    const userId = currentUser?.uid || 'system';

    console.log('Setting up organisation products:', {
      organisationId,
      subscriptionPlan,
      selectedProductIds: productIds
    });

    // Delete existing product mappings
    const orgProductsRef = collection(db, 'c3_organisation_products');
    const existingMappingsQuery = query(
      orgProductsRef,
      where('organisationId', '==', organisationId)
    );
    const existingMappings = await getDocs(existingMappingsQuery);
    const deletePromises = existingMappings.docs.map(doc => deleteDoc(doc.ref));
    await Promise.all(deletePromises);

    // Create new product mappings
    const createPromises = productIds.map(productId => {
      return addDoc(orgProductsRef, {
        organisationId: organisationId,
        productId: productId,
        createdAt: new Date(),
        createdBy: userId
      });
    });
    await Promise.all(createPromises);

    // Also update the organisation document with the digitalProducts array
    const orgRef = doc(db, 'c3_organisations', organisationId);
    await updateDoc(orgRef, {
      digitalProducts: productIds,
      updatedAt: new Date(),
      updatedBy: userId
    });

    console.log('Organisation products setup completed successfully');
  } catch (error) {
    console.error('Error setting up organisation products:', error);
    throw error;
  }
} 